/**
 * Удаляет профиль из кэша ленты (оптимистичное обновление после свайпа).
 * Логика вынесена в чистую функцию для юнит-тестов сценариев.
 */
export function removeProfileFromFeedCache<T extends { userId: string }>(
  list: T[] | undefined,
  toUserId: string,
): T[] | undefined {
  if (!list?.length) return list
  return list.filter((p) => p.userId !== toUserId)
}
